
import React from "react";
import SuccessBackground from "../../assets/images/SuccessBackground.png";
import SuccessImg from "../../assets/images/SuccessImg.png";

const SuccessIconDisplay = React.memo(() => {
    return (
        <>
            <figure className="absolute z-10">
                <img alt="icon" className="w-full" src={SuccessBackground} />
            </figure>
            <figure className="absolute z-10">
                <img alt="icon" className="w-full" src={SuccessImg} />
            </figure>
        </>
    );
});

export default SuccessIconDisplay